import { toSlug } from "common";
import { Link } from "react-router-dom";

export const SlugLink = ({path, children, ...props}: any) => {
  const url = `/${path.map(toSlug).join("/")}`;
  return <Link to={url} {...props}>{children}</Link>;
};
